/** Link targets for displayed contact information. Pure; used by components/ContactLink.tsx. */
const EMAIL_RE = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/;

/** mailto: target for a displayed email address, or null when it does not look like one. */
export function mailtoHref(raw: string): string | null {
  const value = raw.trim();
  return EMAIL_RE.test(value) ? `mailto:${encodeURI(value)}` : null;
}

/** tel: target for a displayed number, or null when it does not look like a phone number. Handles "x123"/"ext. 123". */
export function telHref(raw: string): string | null {
  const text = raw.trim();
  const ext = /(?:\bext\.?|\bx)\s*(\d{1,6})\s*$/i.exec(text);
  const main = ext ? text.slice(0, ext.index) : text;
  const digits = main.replace(/\D/g, '');
  if (digits.length < 7 || digits.length > 15) return null;
  const plus = main.trim().startsWith('+') ? '+' : '';
  return `tel:${plus}${digits}${ext ? `;ext=${ext[1]}` : ''}`;
}
